import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Description = styled.div`
  font-size: 14px;
  line-height: 150%;
  color: ${Colors.GS600};
  margin: 4px 0 16px;
`
